'use strict'

function blankCreateColumnForm () {

  return {
    newColumnUniqueTitleManuallyEdited: false,
    newColumnSubmitAttempted: false,
    newSpreadSheetColumnTitle: '',
    newSpreadSheetUniqueColumnTitle: '',
    newSpreadSheetUniqueColumnType: '',
    newSpreadSheetUniqueColumnRelationshipType: '',
    newSpreadSheetUniqueColumnRelationedSpreadSheet: '',
    newSpreadSheetColumnSelectionMode: 'multiple',
    newSpreadSheetColumnChoices: [],
    newSpreadSheetColumnAutoResize: false,
    newSpreadSheetColumnResizeWidth: null,
    newSpreadSheetColumnResizeHeight: null,
    newSpreadSheetColumnKeepProportions: false,
    newSpreadSheetColumnDateOnly: false,
    newSpreadSheetColumnDurationUnit: 'hours',
    newSpreadSheetColumnSequenceStart: 1
  }
}

function applyCreateColumnFormReset (state) {

  return Object.assign(state, blankCreateColumnForm())
}

module.exports = {
  blankCreateColumnForm,
  applyCreateColumnFormReset
}
